import actionTypes from "../common/actionTypes";

const VERSION_CACHE_KEY = "timesact_version";

function getCachedVersion() {
  try {
    const raw = localStorage.getItem(VERSION_CACHE_KEY);
    if (raw === null) return { exists: false, version: null };
    return { exists: true, version: JSON.parse(raw) };
  } catch {
    return { exists: false, version: null };
  }
}

const cached = getCachedVersion();

export const initialAuthState = {
  error: null,
  user: null,
  isVersionLoaded: cached.exists,
  timesactVersion: cached.version,
  accessToken: null,
  shopifyIdToken: null,
  firebaseAuthIdToken: null,
};

export const hasCachedVersion = cached.exists;
export { VERSION_CACHE_KEY };

const authReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        error: action.payload,
        isVersionLoaded: true,
        timesactVersion: 1, // Fallback to V1 by default.
      };

    case actionTypes.LOGOUT:
      return {
        ...state,
        user: null,
      };

    case actionTypes.SET_USER_TO_STORE:
      return {
        ...state,
        user: action.payload.user,
      };

    case actionTypes.SET_SHOPIFY_ID_TOKEN:
      return {
        ...state,
        shopifyIdToken: action.payload,
      };

    case actionTypes.SET_FIREBASE_AUTH_ID_TOKEN:
      return {
        ...state,
        firebaseAuthIdToken: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
